import InfoOutlineIcon from '@mui/icons-material/InfoOutline'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { Stack, Typography } from '@mui/material'
import { useCiboAutoForm } from './CiboAutoFormContext'

export const ValidationMessages = ({
  fieldName,
  error,
}: {
  fieldName: string
  error?: { message: string }
}) => {
  const { warnings, touched } = useCiboAutoForm()

  const fieldError = error?.message
  const showError = !!fieldError && touched[fieldName]

  const fieldWarning = warnings?.[fieldName]
  const showWarning = fieldWarning && !showError && touched[fieldName]

  return (
    <>
      {showError && (
        <Stack direction="row" alignItems="center" spacing={0.5} mt={0.5}>
          <InfoOutlineIcon sx={{ fontSize: 14, color: 'error.main' }} />

          <Typography color="error.main" variant="caption">
            {fieldError}
          </Typography>
        </Stack>
      )}

      {showWarning && (
        <Stack direction="row" alignItems="center" spacing={0.5} mt={0.5}>
          <WarningAmberIcon sx={{ fontSize: 14, color: 'warning.main' }} />

          <Typography color="warning.main" variant="caption">
            {fieldWarning}
          </Typography>
        </Stack>
      )}
    </>
  )
}
